
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/gupshup",
      function () {
        return require("private-next-pages/compare/gupshup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/gupshup"])
      });
    }
  